// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconArrowUpSmall = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.03 14.177a.75.75 0 01-1.06 0l-3.22-3.22-3.22 3.22a.75.75 0 11-1.06-1.061l3.573-3.573a1 1 0 011.414 0l3.573 3.573a.75.75 0 010 1.06z"
      fill="currentColor"
    />
  );
export default SvgIconArrowUpSmall;
